import { render, staticRenderFns } from "./Parrainage.vue?vue&type=template&id=f445d9fe&"
import script from "./Parrainage.vue?vue&type=script&lang=js&"
export * from "./Parrainage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports